import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SignOutMessage } from "./SignOut.styles";
import { signOutStart } from '../../store/user/user.action';


const SignOut = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const signOutUser = () => dispatch(signOutStart())

    const goToLandingPage = () => {
        navigate('/');
      };

    React.useEffect(() => {
        signOutUser();
        goToLandingPage();
    });


    return (
        <SignOutMessage>Signing Out ...</SignOutMessage>
    );
}

export default SignOut;
